import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { setStoredUser } from "../lib/auth";
import brandFullTransparent from "../assets/brand-full-transparent.png";
import { useLanguage } from "../lib/language";

function Login() {
  const navigate = useNavigate();
  const { language, toggleLanguage, t } = useLanguage();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember_me: true
  });
  const [message, setMessage] = useState("");

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");

    try {
      const response = await api.post("/login", {
        email: formData.email,
        password: formData.password
      });
      setStoredUser(response.data.user, { remember: formData.remember_me });

      if (response.data.user.role === "admin") {
        navigate("/admin");
      } else if (response.data.user.role === "trainer") {
        navigate("/dashboard");
      } else {
        navigate("/exam");
      }
    } catch (error) {
      setMessage(error.response?.data?.error || t("serverError"));
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-hero">
        <div className="auth-toolbar">
          <img src={brandFullTransparent} alt={t("brandTitle")} className="auth-brand-image" />
          <button className="language-toggle language-toggle--ghost" onClick={toggleLanguage} type="button">
            {language === "ar" ? t("switchToEnglish") : t("switchToArabic")}
          </button>
        </div>

        <h1>{t("loginHeroTitle")}</h1>
        <p className="auth-hero__text">{t("loginHeroText")}</p>
      </div>

      <div className="auth-card">
        <h2 className="auth-card__title">{t("loginTitle")}</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder={t("email")}
            value={formData.email}
            onChange={handleChange}
            className="auth-input"
          />

          <input
            type="password"
            name="password"
            placeholder={t("password")}
            value={formData.password}
            onChange={handleChange}
            className="auth-input"
          />

          <label className="auth-checkbox">
            <input
              type="checkbox"
              name="remember_me"
              checked={formData.remember_me}
              onChange={handleChange}
            />
            <span>{t("rememberMe")}</span>
          </label>

          <button type="submit" className="primary-button auth-button">
            {t("loginButton")}
          </button>
        </form>

        {message && <p className="auth-message">{message}</p>}

        <p className="auth-link-text">
          {t("noAccount")} <Link to="/register">{t("registerLink")}</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
